import { render, staticRenderFns } from "./ActivateRateModel.vue?vue&type=template&id=1fd9625f&"
import script from "./ActivateRateModel.vue?vue&type=script&lang=js&"
export * from "./ActivateRateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports